import React, { useRef, useEffect } from "react";
import { View, Animated, StyleSheet } from "react-native";

const DrawLine = (props) => {
  const DrawAnim = useRef(new Animated.Value(0)).current;
  React.useEffect(() => {
    Animated.timing(DrawAnim, {
      toValue: 70,
      duration: 300,
      delay: 300,
      useNativeDriver: false
    }).start();
  });

  return (
    <Animated.View
      style={{
        ...props.style,
        width: DrawAnim,
      }}
    >
      {props.children}
    </Animated.View>
  );
};

export default function UnderLine() {
  return (
    <View style={styles.middleOpening}>
      <DrawLine>
        <View style={styles.LinkBar}></View>
      </DrawLine>
    </View>
  );
}

const styles = StyleSheet.create({
  LinkBar: {
    width: "100%",
    height: 4,
    backgroundColor: "#FFC72C",
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 10,
  },
  middleOpening: {
    alignSelf: "center",
  },
});
